"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19 1H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2m-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2m0 14.97-4.21-1.81-.79-.34-.79.34L5 19.97V7h10z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m5 19.97 5-2.15 5 2.15V7H5z",
  opacity: ".3"
}, "1")], 'BookmarksTwoTone');